module.exports = __webpack_public_path__ + "img/海王.a27c4add.svg";